import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import "./App.css"
import Widget from "./components/Widget/Widget";
import Focus from "./pages/Focus";
import Participation from "./pages/Participation";
import WhoParticipate from "./pages/WhoParticipae";
import Data from "./pages/Data";
import SurveyForm from "./pages/SurveyForm";

function AppLayout() {
  const location = useLocation();

  const hideLayout = location.pathname === "/surveylink";

  return (
    <>
      {!hideLayout && <Navbar />}

      <div className="app-wrapper">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/focus-areas-pillars" element={<Focus />} />
          <Route path="/why-your-participation-matters" element={<Participation />} />
          <Route path="/who-should-participate" element={<WhoParticipate />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/surveylink" element={<SurveyForm />} />
          <Route path="/data" element={<Data />} />
        </Routes>
      </div>

      {!hideLayout && <Widget />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;